import request from '@webtrader/core/request';

import { ENotificationType } from './index';

export interface INotificationSummary {
  unread: number;
  notificationType: ENotificationType;
}

const notificationSummary = () => {
  return request.get<INotificationSummary[]>('/api/notification/v1/summary');
};

export default notificationSummary;
